export const routes = {
  // Public
  HOME: "/",
  UNBOXES: "/unboxing",
  CART: "/cart",
  BOXDETAIL: "/unboxing/box/spin",
  BECOMEREFERRER: "/become-referrer",
  BATTLES: "/battles",
  BATTLEDETAIL: "/battle/play",
  CREATEBATTLE: "/battles/create/battle",

  // Account Base
  ACCOUNT: "/myaccount",

  // Account (RELATIVE - for nested routing)
  ACCOUNT_INDEX: "", // /myaccount

  ACCOUNT_AVATAR: "avatar",
  ACCOUNT_TOPUPS: "topups",
  ACCOUNT_FAIRNESS: "fairness",
  ACCOUNT_DOCUMENTS: "documents",
  ACCOUNT_FREEBOXES: "free-boxes",
  ACCOUNT_WITHDRAWALS: "withdrawals",
  ACCOUNT_TRANSACTIONS: "transactions",
  ACCOUNT_GAMEHISTORY: "game-history",
  ACCOUNT_DELETEACCOUNT: "delete-account",

  // Other pages
  NOTIFICATIONS: "/notification",
  CONTACTUS: "/contact",
  BLOG: "/blog",
  FAQ: "/faq",
  TERMS: "/service/terms",
  PRIVACYPAYMENTS: "/privacy/payments",
  PROVABLYFAIR: "/provably/fair",
  COOKIE: "/cookie/policy",
  AMLPOLICY: "/aml/policy",
  DEALS: "/deals",
  VERIFIED: "/verified",
  RESET: "/reset-password",
  COMINGSOON: "/comingSoon",

  // Social/Auth
  SOCIAL_CALLBACK: "/social/callback",
  SOCIAL_ERROR: "/social/error",
  SIGN_UP: "/sign-up",
  VERIFICATION_CALLBACK: "/user-verification/callback",
  VERIFICATION_ERROR: "/user-verification/error",
  VERIFICATION_EXPIRED: "/user-verification/expired",

  // Payments
  DEPOSIT_SUCCESSFULL: "/deposit-successful/:id",
  WITHDRAW_SUCCESSFULL: "/withdraw-successful/:id",
  WITHDRAW_FAILED: "/withdraw-failed/:id",
  DEPOSIT_FAILED: "/deposit-failed/:id",
  DEPOSIT: "/deposit",
};
